<template>

  <t-page>

    <TypeSupplierDialog :no-option-add="noOptionAdd" @onSubmit="onTypeSupplierDialog"/>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default="{status}">

        <t-input v-model="form.supplierId" hidden/>

        <e-person :person="form.person" :command="command" :error="error_person" @getApi="getEmbedCNPJApi"
                  :status="status"/>


        <b-row>

          <t-input v-model="form.typeSupplierId"
                   :options="typeSupplierOptions"
                   required
                   cols="6"
                   label="Perfil do Fornecedor" select>

            <template #no-options="{search}">
              <b-link @click="addNoOption('modal-type-supplier',search)">Cadastrar Perfil</b-link>
            </template>

            <template #input-group-append>
              <t-button title="Adicionar novo Perfil" @click="openDialogForm('modal-type-supplier')"
                        icon-plus/>
            </template>

          </t-input>

          <t-input cols="6" v-model="form.invoiceEmail"
                   label="E-mail envio Pedido Compras"/>

        </b-row>

        <e-address :address="form.address" :command="command" :status="status" @getApi="getEmbedAddressApi"/>

        <t-input v-model="form.site" label="Site" />

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status"/>

      </template>

    </t-page-form>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import ePerson from "@/views/embed/general/e-person";
import eAddress from "@/views/embed/general/e-address";
import TypeSupplierService from "@/services/modules/purchase/TypeSupplier.service";
import TypeSupplierDialog from "@/views/modules/purchase/TypeSupplierDialog";
export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  components: {ePerson, eAddress, TypeSupplierDialog},
  name: 'SupplierForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      fieldKey: "supplierId",
      form: {
        supplierId: 0,
        supplierNumber: 0,
        typeSupplierId: 0,
        invoiceEmail: "",
        site:"",
        person: {
          /*Embed Person version: 1.0*/
          typePerson: 2,
          name: "",
          shortName: "",
          companyName: "",
          federalTaxpayer: "",
          otherPersonalDocument: "",
          provinceTaxpayer: "",
          provinceTaxpayerExempted: false,
          cityTaxpayer: "",
          /*-------------------------*/
        },
        address: {
          /*Embed Address version: 1.0*/
          country: "BR",
          zipcode: "",
          street: "",
          number: "",
          complement: "",
          neighborhood: "",
          provinceAbbreviation: "",
          cityId: 0
          /*-------------------------*/
        },
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
      },
      /*Embed Person Errors version: 1.0*/
      error_person: {
        name: "",
        federalTaxpayer: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      noOptionAdd: "", //Usado para armazenar o começo do nome digitado para inserção rápida em dialogos na página.
      typeSupplierOptions: []
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      TypeSupplierService.selectList("").then()

      await TypeSupplierService.selectList("").then((list) => {
        this.typeSupplierOptions = list
      }).catch(error => this.responseError(error))

    },
    async onSubmit() {

      await this.setSendingDefault()


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onTypeSupplierDialog(itemInserted) {

      this.form.typeSupplierId = itemInserted.value
      this.typeSupplierOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm()

    await this.mountedContinued()

  },

}
</script>
